import React from 'react'

import ControlledModal from '../../../components/modals/ControlledModal'
import ModalHeader from './ModalHeader'
import ResumePageContent from './ResumePageContent'
import ServiceOrderLoader from './_load/ServiceOrderLoader'

const EditServiceOrderModal = props => {
  return (
    <ControlledModal width="60rem" {...props}>
      <ServiceOrderLoader>
        <ModalHeader />
        <ResumePageContent />
      </ServiceOrderLoader>
    </ControlledModal>
  )
}

export default EditServiceOrderModal
